export default abstract class Colors {
  static glassMorph: string = "#ffffff7a";
  static hmGlassMorph: string = "#c1f1ffcb";
}
